import _ from 'lodash';
import update from 'react-addons-update';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

/**
 * Created by or_p on 11/23/2016.
 */
/* eslint-disable no-loop-func */
import PropTypes from 'prop-types';

import React, { Component } from 'react';

export function fragmentForPublish(elements, pageElement) {
  const includeElementInFragment = (fragment, element) => {
    return element.layout.y <= fragment.yEnd;
  };

  const fragments = [];
  const partitioned = _.partition(elements, element => getElementDefinitionProps(element.type).autoHeight); // it's critical to use element.type and not element so tagged titles will still be considered autoheight
  let autoHeightElements = partitioned[0];
  let fixedHeightElements = partitioned[1];
  autoHeightElements = _.sortBy(autoHeightElements, element => element.layout.y + element.layout.height);
  fixedHeightElements = _.sortBy(fixedHeightElements, element => _.get(element, 'layout.y'));

  let currentFragment;
  while (!_.isEmpty(autoHeightElements)) {
    const element = autoHeightElements[0];
    currentFragment = {
      autoHeightElements: null,
      fixedHeightElements: [],
      y: currentFragment ? currentFragment.yEnd : 0,
      yEnd: element.layout.y + element.layout.height,
    };
    currentFragment.minHeight = currentFragment.yEnd - currentFragment.y;
    const partitioned = _.partition(autoHeightElements, includeElementInFragment.bind(null, currentFragment));
    let lastElementXEnd = 0;
    currentFragment.autoHeightElements = _.sortBy(partitioned[0], element => element.layout.x).map(element => {
      const adjustedElement = update(element, {
        compProps: {
          $merge: {
            marginLeft: element.layout.x - lastElementXEnd,
            marginTop: element.layout.y - currentFragment.y,
            marginBottom: currentFragment.yEnd - (element.layout.y + element.layout.height),
            position: 'relative',
            flexGrow: 0,
            flexShrink: 0,
            display: 'inline-block',
            top: 0,
            left: 0,
            verticalAlign: 'top',
          }
        },
        layout: {
          x: {
            $set: null,
          },
          y: {
            $set: null,
          },
        }
      });
      lastElementXEnd = element.layout.x + element.layout.width;
      return adjustedElement;
    });
    autoHeightElements = partitioned[1];
    fragments.push(currentFragment);
  }

  currentFragment = {
    autoHeightElements: [],
    fixedHeightElements: [],
    y: currentFragment ? currentFragment.yEnd : 0,
    yEnd: pageElement.layout.height,
  };
  fragments.push(currentFragment);
  currentFragment.minHeight = currentFragment.yEnd - currentFragment.y;

  let i = 0;
  while (!_.isEmpty(fixedHeightElements)) {
    const currentFragment = fragments[i];
    while (!_.isEmpty(fixedHeightElements) && (fixedHeightElements[0].layout.y < currentFragment.yEnd || i === fragments.length - 1)) {
      const element = fixedHeightElements.shift();
      currentFragment.fixedHeightElements.push(
        update(element, {
          layout: {
            y: {
              $set: element.layout.y - currentFragment.y,
            }
          }
        })
      );
    }
    i++;
  }
  return fragments;
}

export function renderInFragmentedContainers(elements, pageElement, renderElement) {
  const fragments = fragmentForPublish(_.filter(elements, element => (!element.parentId)), pageElement);
  return _.map(fragments, fragment => {
    return (<div style={{
      width: '100%',
      minHeight: fragment.minHeight,
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
    }}>
      {
        fragment.fixedHeightElements.map(element => {
          return renderElement(element);
        })
      }
      {
        fragment.autoHeightElements.map(element => {
          return renderElement(element);
        })
      }
    </div>);
  });
}